/**
 * Panel component module.
 * @module shared/components/Panel
 *
 */
import React from 'react';
import PropTypes from 'prop-types';
import styled, {css} from 'styled-components/macro';
import {Column, Icon, Row} from '../index';

const _Title = styled.span`
  font-family: ${props => props.theme.bodyText.name};
  color: ${props => props.theme.dark ? 'rgba(255,255,255,.9)' : 'rgba(0,0,0,.9)'};
`;

// ETODO move overflow?
const _Panel = styled.div`
  width: 200px;
  flex: 0 0 200px;
  padding: 5px;
  ${props => props.margin && `margin: ${props.margin}`};
  border-radius: 6px;
  overflow-y: auto;
  ${props => {
    if (props.theme.neumorphic) {
      return css`
        box-shadow: inset 1px 1px 0 0 rgba(255, 255, 255, 0.1), inset -1px -1px 0 0 rgba(0, 0, 0, 0.3);
        background-image: linear-gradient(to bottom right, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0.15));
        background-color: ${props.theme.tileBackgroundColor};
      `;
    }
    return css`
      background-color: ${props.theme.dark ? 'rgba(255,255,255, 0.1)' : 'rgba(0,0,0, 0.1)'};
    `;
  }};
}

`;

/**
 * Panel component
 * @name Panel
 */
const Panel = props => {
  const {title, content, close, margin} = props;

  return <_Panel margin={margin}>
    <Column justifySubColumn={'top'}
            showDividers={props.showDividers}
            alignItems={'left'}>
      <Row height={'fit-content'}
           wrap={false}
           justifySubRow={'space between'}
           alignItems={'middle'}>
        <_Title>{title}</_Title>
        {close && <Icon svg={'close'} height={'20px'} width={'20px'} action={close}/>}
      </Row>
      {typeof content === 'function' ? content() : content}
    </Column>
  </_Panel>;
};

export default Panel;

// ETODO THESE PROPS ARE NOT FINAL (e.g. close will have to be changed or expanded).
//  If you need to use this component and this message is still here, that's bad
Panel.propTypes = {
  /**
   * Panel title
   */
  title: PropTypes.string.isRequired,
  /**
   * Panel JSX content (or a function that returns it)
   */
  content: PropTypes.oneOfType([PropTypes.node, PropTypes.func]).isRequired,
  // width: PropTypes.string,
  /**
   * Function to close the panel
   */
  close: PropTypes.func,
  /**
   * Panel margin
   */
  margin: PropTypes.string,
  /**
   * If true shows column dividers
   */
  showDividers: PropTypes.bool,
};
